var render, staticRenderFns
import script from "./SplashTopBar.vue?vue&type=script&lang=js&"
export * from "./SplashTopBar.vue?vue&type=script&lang=js&"
import style0 from "./SplashTopBar.vue?vue&type=style&index=0&id=3b55cb9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55cb9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b55cb9c')) {
      api.createRecord('3b55cb9c', component.options)
    } else {
      api.reload('3b55cb9c', component.options)
    }
    
  }
}
component.options.__file = "src/layouts/app/SplashTopBar.vue"
export default component.exports